interface LogoProps {
  size?: number
  className?: string
}

export default function Logo({ size = 32, className }: LogoProps) {
  return (
    <img
      src="/favicon.svg"
      width={size}
      height={size}
      className={className}
      alt="ESI Energy Conductor"
      style={{ borderRadius: size * 0.18 }}
    />
  )
}
